/**
 * Nov. 2024
 * @deprecated Use cclib instead.
 * Everything in this file has an appropriate replacement in cclib.
 * cclib has better type safety, is easier to use, and is more stable than anything in this file
 * this file is purely leftover because lahey uses parts of it.
 */

import {
  cvOutputData,
  getCareerAvailableYears
} from "../lib/cvDataUtilities.js";
import { isTimeWithinRange, zeroPad } from "../lib/dateHelpers.js";
import { getProp } from "../lib/frontendUtilities.js";
import { getKey, keys } from "../lib/utilities.js";

/**
 * @deprecated Use cclib instead.
 */
function getYearText(obj) {
  return (
    obj.getMonth() +
    1 +
    "/" +
    obj.getDate() +
    "/" +
    (obj.getYear() + 1900 + "").slice(-2)
  );
}
/**
 * @deprecated Use cclib instead.
 */
function generateHTML(newDef, elementArray, divider = "") {
  // Parsing structure variable; Can definitely be pulled out to act like input map parsing of a format
  let htmlString = [];
  elementArray.map(function (item) {
    const extraStyling = item.isMentorField
      ? "font-weight: bold; color: darkblue;"
      : "";
    if (item.type === "header") {
      htmlString.push(
        '<h5 style="margin-bottom: 10px; margin-top: 20px; font-weight: bold; text-decoration: underline;">' +
          item.name +
          "</h4>"
      );
    } else if (item.type === "extraction") {
      var extracted = item.val(newDef);
      htmlString.push(
        '<h5 style="margin-bottom: 20px;">' +
          item.name +
          ': <a href="#" class="jump" data-id="' +
          extracted.id +
          '" data-field="' +
          extracted.field +
          '"><span class="confExtraction" data-key="' +
          item.key +
          '">' +
          extracted.text +
          '</span><span class="glyphicon glyphicon-share-alt" style="margin-left: 5px; cursor: pointer;"></span></a></h4>'
      );
    } else if (item.type === "string") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;">' +
          (item.name == null
            ? ""
            : '<h5 style="width: 300px;display: inline-block; margin-right: 10px;' +
              extraStyling +
              '">' +
              item.name +
              ": </h5>") +
          '<input class="form-control confString' +
          (item.optional ? " cc-optional" : "") +
          '" name="' +
          item.key +
          '" data-key="' +
          item.key +
          '" value="' +
          (item.value || "") +
          '" style="width: 200px; display: inline-block;"></div>'
      );
    } else if (item.type === "date") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;">' +
          (item.name == null
            ? ""
            : '<h5 style="width: 300px;display: inline-block; margin-right: 10px;' +
              extraStyling +
              '">' +
              item.name +
              ": </h5>") +
          '<input type="date" class="form-control confDate' +
          (item.optional ? " cc-optional" : "") +
          '" name="' +
          item.key +
          '" data-key="' +
          item.key +
          '" value="' +
          (item.value || "") +
          '" style="width: 200px; display: inline-block;"></div>'
      );
    } else if (item.type == "paragraph") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="display: inline-block; margin-right: 10px;' +
          extraStyling +
          '" class="confParagraphTitle" data-key="' +
          item.key +
          '">' +
          item.name +
          ': </h5><textarea class="form-control confParagraph"' +
          (item.optional ? " cc-optional" : "") +
          ' data-key="' +
          item.key +
          '" style="width: 100%; height: 100px; display: inline-block;"></textarea></div>'
      );
    } else if (item.type == "select") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;">' +
          (item.name == null
            ? ""
            : '<h5 style="width: 300px;display: inline-block; margin-right: 10px;' +
              extraStyling +
              '">' +
              item.name +
              ": </h5>") +
          '<select class="form-control confSelect"' +
          (item.optional ? " cc-optional" : "") +
          ' data-key="' +
          item.key +
          '" style="width: auto; display: inline-block;"><option value="choose">Choose</option>' +
          item.options
            .map(function (n) {
              return '<option value="' + n + '">' + n + "</option>";
            })
            .join("") +
          "</select></div>"
      );
    } else if (item.type == "float") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="display: inline-block; margin-right: 10px;' +
          extraStyling +
          '">' +
          item.name +
          ': </h5><input class="form-control confFloat"' +
          (item.optional ? " cc-optional" : "") +
          ' data-key="' +
          item.key +
          '" value="" style="width: 200px; display: inline-block;"></div>'
      );
    } else if (item.type == "integer") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="width: 300px;display: inline-block; margin-right: 10px;' +
          extraStyling +
          '">' +
          item.name +
          ': </h5><input class="form-control confInteger"' +
          (item.optional ? " cc-optional" : "") +
          ' data-key="' +
          item.key +
          '" value="" style="width: 200px; display: inline-block;"></div>'
      );
    } else if (item.type == "html") {
      htmlString.push(item.html);
    } else if (item.type == "check") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%; padding: 5px; border-radius: 5px;"><input class="confCheck"' +
          (item.optional ? " cc-optional" : "") +
          ' type="checkbox" data-key="' +
          item.key +
          '" style="margin-right: 5px; display: inline-block;"><h5 style="display: inline; margin-right: 10px;' +
          extraStyling +
          '">' +
          item.name +
          ": </h5></div>"
      );
    } else if (item.type == "previous") {
      htmlString.push(
        '<div style="margin-bottom: 5px;display: inline-block;width: 100%;"><h5 style="' +
          (item.paragraph ? "" : "width: 300px;") +
          'display: inline-block; margin-right: 10px;" class="confPreviousTitle" data-key="' +
          item.key +
          '">' +
          item.name +
          ': </h5><h5 class="confPrevious" data-key="' +
          item.key +
          '" style="' +
          (item.paragraph ? "width: 100%;" : "margin-left: 10px;") +
          'display: inline-block;"></h5></div>'
      );
    } else if (item.type == "table") {
      htmlString.push(
        '<h5 style="margin-bottom: 10px; margin-top: 20px; font-weight: bold; text-decoration: underline;' +
          extraStyling +
          '">' +
          item.name +
          "</h4>" +
          `<div style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1rem">${generateHTML(newDef, item.sections)}</div>`
      );
    } else if (item.type == "inline-table") {
      htmlString.push(
        `<div style="display:grid;grid-template-columns:1fr 1fr;width:min-content">${generateHTML(newDef, item.sections)}</div>`
      );
    }
  });
  return htmlString.join(divider);
}

/**
 * @deprecated Use cclib instead.
 */
function isReadOnly(
  contextConstants,
  contextState,
  conference,
  yearData,
  viewYear,
  type,
  thisOpts
) {
  let { user, cvOwner } = contextConstants;
  let { viewAsState } = contextState;
  thisOpts = thisOpts || {};
  if (thisOpts.readOnly) return true;
  let editAccessOverride =
    (user.settings.accessFilters || []).length > 0 &&
    user.settings.conferenceTabAccess == "editAccess";
  if (thisOpts.noOverride) editAccessOverride = false;
  let menteeOverride = false;
  let mentorOverride = false;

  if (viewAsState !== "undefined" && editAccessOverride) {
    editAccessOverride = false;
    if (viewAsState.career == "mentee") menteeOverride = true;
    else if (viewAsState.career == "mentor") mentorOverride = true;
    else editAccessOverride = true;
  }

  let menteeAccess =
    user.id == cvOwner.id || editAccessOverride || menteeOverride;
  let mentorAccess =
    (conference.mentors[user.id] || {})[cvOwner.id] != null ||
    editAccessOverride ||
    mentorOverride;
  let isOpen =
    !!(conference.openYears[viewYear] || { open: false }) || editAccessOverride;
  return (
    !isOpen ||
    (yearData.status != type && !mentorAccess && !thisOpts.noOverride) ||
    (type == "mentee" && !menteeAccess) ||
    (type == "mentor" && !mentorAccess)
  );
}

// Update helpers updateCareerYear, updateCareerInputs, setFieldStatus
//
/**
 * @deprecated Use cclib instead.
 */
function updateCareerYear(
  isOpen,
  yearData,
  overviewState,
  availableYears,
  startDate,
  endDate,
  updateCallback
) {
  $(".careerYear").html(
    "<span>" +
      getYearText(new Date(startDate)) +
      " - " +
      getYearText(new Date(endDate)) +
      "</span>" +
      (!isOpen || yearData.status == "closed"
        ? '<span class="glyphicon glyphicon-lock" style="margin-left: 10px;"></span>'
        : "")
  );
  $(".careerYearPrev")
    .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden")
    .unbind("click")
    .click(function () {
      // Only go back if previous data exists
      overviewState.yearIndex--;
      updateCallback();
    });
  $(".careerYearNext")
    .toggle(overviewState.yearIndex < availableYears.length - 1)
    .unbind("click")
    .click(function () {
      overviewState.yearIndex++;
      updateCallback();
    });
}

// Checks whether a field has errors
/**
 * @deprecated Use cclib instead.
 */
function careerErrorCheck(
  isOpen,
  newDef,
  structure,
  viewYear,
  dataPrefix,
  menteeAccess,
  mentorAccess
) {
  let yearData = newDef.career[viewYear];

  let errors = [];
  let hasError = false;
  if (!isOpen) {
  } else if (yearData.status == "mentee") {
    const data = getKey(yearData, "data", {});

    // reduce here pretty much just flattens the structure by one level
    // if we have a table or an inline-table, it replaces that entry with it's sections
    // this flattening only effects the error checking, nothing else
    hasError = structure
      .reduce((prev, curr) => {
        if (curr.type === "table" || curr.type === "inline-table") {
          return [...prev, ...curr.sections];
        } else {
          return [...prev, curr];
        }
      }, [])
      .filter(function (n) {
        return (
          [
            "header",
            "extraction",
            "previous",
            "html",
            "table",
            "inline-table"
          ].indexOf(n.type) == -1
        );
      })
      .some(function (item) {
        if (["string", "paragraph", "select", "date"].indexOf(item.type) >= 0) {
          if (!item.optional && !item.isMentorField) {
            return String(data[dataPrefix + item.key] || "").trim().length == 0;
          } else {
            return false;
          }
        } else if (["float", "integer"].indexOf(item.type) >= 0) {
          return (
            data[dataPrefix + item.key] == null ||
            isNaN(data[dataPrefix + item.key])
          );
        } else if (item.type == "check") {
          return !data[dataPrefix + item.key];
        } else if (item.type == "inline-table") {
        }
        return true;
      });
  }

  if (!isOpen) {
    $(".statusSubheader").text("");
    $(".errorSubheader").text("");
  } else if (yearData.status == "mentee" && menteeAccess) {
    $(".statusSubheader").text(
      "When finished, submit for review to notify your appraiser"
    );
    $(".errorSubheader").text(errors.join(", "));
  } else if (yearData.status == "mentor" && mentorAccess) {
    $(".statusSubheader").text("When finished, mark as finalized");
    $(".errorSubheader").text("Missing information required before finalizing");
  } else {
    $(".statusSubheader").text("");
    $(".errorSubheader").text("");
  }

  $(".statusSubheader").toggle(!hasError);
  $(".errorSubheader").toggle(hasError);

  $(".errorSubheader")
    .unbind("click")
    .click(function () {
      $(".has-error")[0].scrollIntoView();
    });
  $(".nextStatus").toggleClass("disabled", hasError);
}
// These class jqueries are for putting the input into cv
// Data prefix example = "lah_"
/**
 * @deprecated Use cclib instead.
 */
function updateCareerInputs(
  isOpen,
  newDef,
  user,
  backend,
  structure,
  viewYear,
  dataPrefix,
  menteeAccess,
  mentorAccess,
  checkSave
) {
  $(".confCheck")
    .unbind("change")
    .on("change", function () {
      const key = getProp(this, "key");
      const tf = $(this).is(":checked");
      let data = newDef.career[viewYear].data;
      data[dataPrefix + key] = tf;
      $(this)
        .parent()
        .css("border", tf ? "" : "2px solid #a94442");
      backend.send(
        "log",
        "q - " + key + " - tf - " + tf + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  // confString and confDate have the same handler, maybe combine into one.

  $(".confString")
    .unbind("input")
    .on("input", function () {
      const key = getProp(this, "key");
      let text = String($(this).val());
      let data = newDef.career[viewYear].data;

      const isErr = !this.classList.contains("cc-optional")
        ? !(text && text.trim().length)
        : false;
      $(this).parent().toggleClass("has-error", isErr);
      if (isErr) text = null;

      data[dataPrefix + key] = text;

      backend.send(
        "log",
        "q - " + key + " - text - " + text + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  $(".confDate")
    .unbind("input")
    .on("input", function () {
      const key = getProp(this, "key");
      let text = String($(this).val());
      let data = newDef.career[viewYear].data;

      const isErr = !this.classList.contains("cc-optional")
        ? !(text && text.trim().length)
        : false;
      $(this).parent().toggleClass("has-error", isErr);
      if (isErr) text = null;

      data[dataPrefix + key] = text;

      backend.send(
        "log",
        "q - " + key + " - text - " + text + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  $(".confParagraph")
    .unbind("input")
    .on("input", function () {
      const key = getProp(this, "key");
      let text = String($(this).val());
      let data = newDef.career[viewYear].data;

      const item = structure.find(function (n) {
        return n.key == key;
      });

      let isErr = !item?.optional
        ? text == null || text.trim().length == 0
        : false;
      if (isErr) text = null;

      if (item?.wordLimit != null) {
        const numWords = (text || "")
          .split(/(?: |\n)+/)
          .filter(function (text) {
            return text.trim().length > 0;
          }).length;
        if (numWords > item.wordLimit) isErr = true;
        $(this)
          .parent()
          .find(".confParagraphTitle")
          .text(item.name + ": " + numWords + "/" + item.wordLimit + " words")
          .css("color", numWords > item.wordLimit ? "#ad310e" : "");
      }

      $(this).parent().toggleClass("has-error", isErr);
      data[dataPrefix + key] = text;

      backend.send(
        "log",
        "q - " + key + " - text - " + text + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  $(".confSelect")
    .unbind("change")
    .on("change", function () {
      const key = getProp(this, "key");
      let text = $(this).val();
      if (text == "choose") text = null;

      const isErr = text == null;
      $(this).parent().toggleClass("has-error", isErr);
      if (isErr) text = null;

      let data = newDef.career[viewYear].data;
      data[dataPrefix + key] = text;

      backend.send(
        "log",
        "q - " + key + " - select - " + text + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  $(".confFloat")
    .unbind("input")
    .on("input", function () {
      const key = getProp(this, "key");
      let float = parseFloat($(this).val());

      const isErr = isNaN(float);
      $(this).parent().toggleClass("has-error", isErr);
      if (isErr) float = null;

      let data = newDef.career[viewYear].data;
      data[dataPrefix + key] = float;

      backend.send(
        "log",
        "q - " + key + " - float - " + float + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  $(".confInteger")
    .unbind("input")
    .on("input", function () {
      const key = getProp(this, "key");
      let int = parseInt($(this).val());

      const isErr =
        isNaN(int) || parseFloat($(this).val()) != parseInt($(this).val());
      $(this).parent().toggleClass("has-error", isErr);
      if (isErr) int = null;

      let data = newDef.career[viewYear].data;
      data[dataPrefix + key] = int;

      backend.send(
        "log",
        "q - " + key + " - int - " + int + " - user " + (user || {}).id
      );
      careerErrorCheck(
        isOpen,
        newDef,
        structure,
        viewYear,
        dataPrefix,
        menteeAccess,
        mentorAccess
      );
      checkSave();
    });

  // I feel like this error check is called an excessive amount.
  careerErrorCheck(
    isOpen,
    newDef,
    structure,
    viewYear,
    dataPrefix,
    menteeAccess,
    mentorAccess
  );
}

// Filling the data and checking the error status of each field
//
/**
 * @deprecated Use cclib instead.
 */
function setFieldStatus(
  contextConstants,
  contextState,
  conference,
  dataPrefix,
  elementArray,
  yearData,
  viewYear,
  lastYearData,
  opts
) {
  let data = getKey(yearData, "data", {});
  let lastData = getKey(lastYearData, "data", {});
  let overviewState = getKey(
    contextState.sectionState,
    contextState.section,
    {}
  );

  elementArray.map(function (item) {
    let isErr = data[dataPrefix + item.key] == null ? !item.optional : false;

    if (["string", "float", "integer", "date"].indexOf(item.type) >= 0) {
      if (item.type === "float") {
        isErr = isErr || isNaN(data[dataPrefix + item.key]);
      } else if (item.type === "int") {
        isErr = isErr || isNaN(data[dataPrefix + item.key]);
      } else if (item.type === "string") {
        isErr =
          isErr ||
          (String(data[dataPrefix + item.key] || "").trim().length === 0 &&
            !item.optional);
      } else if (item.type === "date") {
        isErr =
          isErr ||
          (String(data[dataPrefix + item.key] || "").trim().length === 0 &&
            !item.optional);
      }
      $(
        ".conf" +
          {
            string: "String",
            float: "Float",
            integer: "Integer",
            date: "Date"
          }[item.type] +
          '[data-key="' +
          item.key +
          '"]'
      )
        .attr("value", data[dataPrefix + item.key] || "")
        .val(data[dataPrefix + item.key] || "")
        .prop("readonly", item.readOnly)
        .prop(
          "disabled",
          isReadOnly(
            contextConstants,
            contextState,
            conference,
            yearData,
            viewYear,
            "mentee",
            opts
          )
        )
        .parent()
        .toggleClass("has-error", isErr);
    } else if (item.type == "paragraph") {
      if (!item.optional) {
        isErr =
          isErr || String(data[dataPrefix + item.key] || "").trim().length == 0;
      } else {
        isErr = false;
      }

      if (item.wordLimit != null) {
        let numWords = String(data[dataPrefix + item.key] || "")
          .split(/(?: |\n)+/)
          .filter(function (text) {
            return text.trim().length > 0;
          }).length;
        if (numWords > item.wordLimit) isErr = true;
        $('.confParagraphTitle[data-key="' + item.key + '"]')
          .text(item.name + ": " + numWords + "/" + item.wordLimit + " words")
          .css("color", numWords > item.wordLimit ? "#ad310e" : "");
      }

      let paragraphUser = "mentee";
      if (item.isMentorField) {
        paragraphUser = "mentor";
        isErr = false;
      }

      $('.confParagraph[data-key="' + item.key + '"]')
        .val(data[dataPrefix + item.key] || "")
        .prop(
          "disabled",
          isReadOnly(
            contextConstants,
            contextState,
            conference,
            yearData,
            viewYear,
            paragraphUser,
            opts
          )
        )
        .parent()
        .toggleClass("has-error", isErr);
      if (yearData.status === "finalized") {
        $('.confParagraph[data-key="' + item.key + '"]').prop("disabled", true);
      }
    } else if (item.type === "check") {
      isErr = isErr || !data[dataPrefix + item.key];
      $('.confCheck[data-key="' + item.key + '"]')
        .prop(
          "disabled",
          isReadOnly(
            contextConstants,
            contextState,
            conference,
            yearData,
            viewYear,
            "mentee",
            opts
          )
        )
        .prop("checked", !!data[dataPrefix + item.key])
        .parent()
        .css("border", isErr ? "2px solid #a94442" : "");

      if (data[dataPrefix + item.key])
        $('.confCheck[data-key="' + item.key + '"]').attr("checked", "true");
      else $('.confCheck[data-key="' + item.key + '"]').removeAttr("checked");
    } else if (item.type === "select") {
      if (item.options.indexOf(data[dataPrefix + item.key]) === -1)
        delete data[dataPrefix + item.key];
      let selectEl = $('.confSelect[data-key="' + item.key + '"]');
      selectEl
        .prop(
          "disabled",
          isReadOnly(
            contextConstants,
            contextState,
            conference,
            yearData,
            viewYear,
            "mentee",
            opts
          )
        )
        .val(data[dataPrefix + item.key] || "choose")
        .parent()
        .toggleClass("has-error", isErr);
      selectEl.find("option").attr("selected", false);
      selectEl
        .find(
          'option[value="' + (data[dataPrefix + item.key] || "choose") + '"]'
        )
        .attr("selected", true);
    } else if (item.type === "exclusion") {
      // debugger;
      let extracted = item.val(contextState.newDef);
      $('.confExtraction[data-key="' + item.key + '"]')
        .text(extracted.text)
        .parent()
        .attr("data-field", extracted.field)
        .attr("data-id", extracted.i);
    } else if (item.type === "previous") {
      $('.confPrevious[data-key="' + item.key + '"]')
        .text(lastData[dataPrefix + item.key.replace("_prev", "")] || "")
        .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden");
    } else if (item.type === "table" || item.type === "inline-table") {
      setFieldStatus(
        contextConstants,
        contextState,
        conference,
        dataPrefix,
        item.sections,
        yearData,
        viewYear,
        lastYearData,
        opts
      );
    }

    // Previous year values
    const colleagueIdInput = $("input[name='colleague_id']").first();
    // if no value, set last years
    !colleagueIdInput.val().length &&
      colleagueIdInput.val(lastYearData?.data?.[dataPrefix + "colleague_id"]);
    colleagueIdInput.parent().toggleClass("has-error", isErr);
  });
}

// Template output for review format; Maybe pull this out to make similar to formats?
/**
 * @deprecated Use cclib instead.
 */
function createOutput(
  templateName,
  contextState,
  contextConstants,
  backend,
  conference,
  downloadName,
  structure,
  callbackProps,
  callback
) {
  const { section, sectionState, format, newDef } = contextState;
  const { user, cvOwner, formats } = contextConstants;
  $(".reviewForm")
    .unbind("click")
    .click(function () {
      const template = "/templateFiles/reports/" + templateName;
      const oReq = new XMLHttpRequest();
      oReq.open("GET", template, true);
      oReq.responseType = "arraybuffer";
      oReq.onload = async function () {
        const arrayBuffer = oReq.response;
        const content = new Uint8Array(arrayBuffer);
        const zip = new PizZip(content);
        const doc = new Docxtemplater();
        doc.loadZip(zip);
        doc.setOptions({ linebreaks: true });
        const overviewState = getKey(sectionState, section, {});
        const yearInfo = getCareerAvailableYears(
          newDef,
          conference,
          user,
          cvOwner
        );
        const availableYears = yearInfo.availableYears;
        const baseYear = yearInfo.baseYear;
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        ) {
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        }
        const viewYear = availableYears[overviewState.yearIndex];
        const yearData = newDef.career[viewYear];
        const lastYearData = newDef.career[viewYear - 1];

        const cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
        const month = cutoff.split("/")[0] || "1";
        const date = cutoff.split("/")[1] || "1";

        const startDate = new Date(
          month + "/" + date + "/" + viewYear
        ).getTime();
        const endDate =
          new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
          1000 * 60 * 60 * 24;

        let outputSource = formats[format];
        if (formats[format].outputs != null) {
          const outputNames = keys(formats[format].outputs);
          if (outputNames.indexOf($("#cvOutputFormat").val()) >= 0) {
            outputSource = formats[format].outputs[$("#cvOutputFormat").val()];
          } else {
            outputSource = formats[format].outputs[outputNames[0]];
          }
        }
        cvOutputData(
          newDef,
          {
            id: cvId,
            cvOwner,
            type: "partial",
            start: { month, year: viewYear },
            end: { month, year: viewYear + 1 },
            filter: function (time) {
              return isTimeWithinRange(time, startDate, endDate);
            },
            formats,
            contextState,
            outputSource,
            custom: { dateLimited: true }
          },
          function (data) {
            // This is the part of the code where the data goes from cv to download based on the structure entries
            callback(data, structure, callbackProps);
            doc.setData(data);
            try {
              doc.render();
            } catch (error) {
              console.log({
                message: error.message,
                name: error.name,
                stack: error.stack,
                properties: error.properties
              });
              throw error;
            }

            const dateString =
              new Date().getYear() +
              1900 +
              "-" +
              zeroPad(new Date().getMonth() + 1, 2) +
              "-" +
              zeroPad(new Date().getDate(), 2);
            const docFile = doc.getZip().generate({
              type: "blob",
              mimeType:
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            });

            const fileName =
              cvOwner.name
                .split(",")
                .join("")
                .split(".")
                .join("")
                .split(" ")
                .join("_") +
              "_" +
              dateString +
              downloadName.replaceAll(/ /g, "_") +
              ".docx";

            backend.send("saveLog", {
              id: user.id,
              path: window.location.pathname,
              action: JSON.stringify({
                type: "download " + downloadName,
                title: fileName.split("\n").join("")
              }),
              context: JSON.stringify({
                agent: window.navigator.userAgent,
                params: window.location.search,
                cvId: cvId,
                cvOwner: cvOwner.id
              })
            });

            saveAs(docFile, fileName.split("\n").join(""));
          }
        );
      };
      oReq.send();
    });
}
export {
  careerErrorCheck,
  createOutput,
  generateHTML,
  getYearText,
  isReadOnly,
  setFieldStatus,
  updateCareerInputs,
  updateCareerYear
};
// Conference open data format
//  {
//    openYears: { '2024': { open: true } },
//  }
export const isAnyConferenceOpen = (conference) => {
  return Object.keys(conference.openYears).some(
    (year) => conference.openYears[year].open
  );
};

export const mostRecentOpenConference = (conference) => {
  let latest = Math.max(
    ...Object.keys(conference.openYears)
      .filter((year) => conference.openYears[year].open)
      .map((y) => parseInt(y))
  );
  if (!(isNaN(latest) && latest != null)) {
    return latest.toString();
  } else {
    return null;
  }
};
